import Constant from '@/common/constant/Constant';
import { reloadAfterApproveAnonymousTicket, reloadAfterRejectAnonymousTicket } from '@/component/chatThread/handler/DetailTicketHandler';
import { Button, Dialog, DialogActions, DialogContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { I18n } from 'aws-amplify';
import { reloadPanelApproveAnonymousTicket,reloadPanelRejectAnonymousTicket } from '../handler/TicketListHandler';

export const DialogNotificationTicketApprovedBefore = props => {
    const isOpen = props.isTicketUpdatedBefore;

    const onCloseConfirm = () => {
        if (props.parentPanelScreen === Constant.PANEL_TYPE.HELPDESK_TICKET_LIST) {
            if (props.approvalFlagAfterUpdated === Constant.ANONYMOUS_TICKET_STATUS.APPROVE) {
                reloadPanelApproveAnonymousTicket({ ...props });
            } else {
                reloadPanelRejectAnonymousTicket({ ...props });
            }
        }
        if(props.parentPanelScreen === Constant.PANEL_TYPE.DETAIL_TICKET){
            if (props.approvalFlagAfterUpdated === Constant.ANONYMOUS_TICKET_STATUS.APPROVE) {
                reloadAfterApproveAnonymousTicket({ ...props });
            } else {
                reloadAfterRejectAnonymousTicket({ ...props });
            }
        }
        props.setApprovalFlagAfterUpdated('');
        props.setIsTicketUpdatedBefore(false);
    };

    return (
        <Dialog
            open={isOpen}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {I18n.get('COMMSG030')}
                    <IconButton
                        className="close"
                        onClick={(event, reason) => onCloseConfirm(event, reason)}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="confirm-dialog-button"
                    variant="contained"
                    color="primary"
                    onClick={onCloseConfirm}
                >
                    {I18n.get('COMBTN002')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
